import { TextInput } from '@mantine/core';
import { IFormInputSpecMeasurementColumnAggregator } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a measurement column aggregator input.
 */
export default function MeasurementColumnAggregatorInputPreview({
  spec,
}: {
  spec: IFormInputSpecMeasurementColumnAggregator;
}) {
  return <TextInput required={spec.required} readOnly size="sm" />;
}
